import { useEffect } from 'react';
import type { ReactNode } from 'react';

/** Нижняя шторка. Все модалки приложения — это она. */
export function Sheet({ open, onClose, title, children }: {
  open: boolean; onClose: () => void; title?: string; children: ReactNode;
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center" role="dialog" aria-modal="true">
      <button className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} aria-label="Закрыть" />
      <div className="relative w-full max-w-md rounded-t-3xl border-t border-line bg-surface p-5
                      pb-[max(20px,env(safe-area-inset-bottom))] rise">
        <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-line" />
        {title && <h2 className="mb-3 font-display text-lg">{title}</h2>}
        {children}
      </div>
    </div>
  );
}
